import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import type { HermesSvg } from "../../icons/svg.model";

@Component({
    selector: "h-svg-icon[name]",
    templateUrl: "./svg-icon.component.html",
    styleUrls: ["./svg-icon.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
    public name = input<HermesSvg | undefined>(undefined);
    public testId = input<string | undefined>(undefined);
    public ariaLabel = input<string | undefined>(undefined);
    public ariaHidden = input<boolean>(true);
    public role = input<string>("presentation");

    /**
     * Provide explicit viewBox for svg element
     *
     * Optional, but may be required in some cases.
     * If provided, it SHOULD match the actual viewBox of the svg icon.
     */
    public viewBox = input<string | undefined>(undefined);

    public height = input<string | undefined>("100%");
    public width = input<string | undefined>("100%");
    public fill = input<string | undefined>(undefined);
    public stroke = input<string | undefined>(undefined);
}
